import { request } from '../utils/request'
import { querystring } from '../utils/index'

export default {
  getallregulators: option =>
    request('v1/regulator/getallregulators', option, true, false), // 查询监管机构树
  addregulator: option =>
    request('v1/regulator/addregulator', option, true, false), // 新增监管机构
  updateregulator: option =>
    request('v1/regulator/updateregulator', option, true, false), // 修改监管机构
  deleteregulator: option => {
    const urls = querystring(option)
    return request('v1/regulator/deleteregulator' + urls, {}, true, false) // 删除监管机构
  },
  getregulator: option => {
    const urls = querystring(option)
    return request('v1/regulator/getregulator' + urls, {}, true, false) // 查询监管机构详情
  },
  getflapcategorys: option =>
    request('v1/category/getflapcategorys', option, true, false), // 查行业分类
  getsupervisions: option =>
    request('v1/supervision/getsupervisions', option, true, false) // 查询检后监管记录
}
